/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {sendChatMessages} from '../api'

export const useMutationSendChatMessages = createReactQueryMutationHook('sendChatMessages', sendChatMessages)
